import { render, staticRenderFns } from "./supplier.vue?vue&type=template&id=626bbcfa&scoped=true"
import script from "./supplier.vue?vue&type=script&lang=js"
export * from "./supplier.vue?vue&type=script&lang=js"
import style0 from "./supplier.vue?vue&type=style&index=0&id=626bbcfa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626bbcfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('626bbcfa')) {
      api.createRecord('626bbcfa', component.options)
    } else {
      api.reload('626bbcfa', component.options)
    }
    module.hot.accept("./supplier.vue?vue&type=template&id=626bbcfa&scoped=true", function () {
      api.rerender('626bbcfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/resource/supplier.vue"
export default component.exports